/**
 * @module app.cd
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { ClientDataModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(ClientDataModule.registrationKey, ClientDataModule);

    config.globalResources([
        // elements

        // elements/members
        './elements/members/member-display',

        // elements/providers
        './elements/providers/provider-location-display'

        // value-converters
    ]);
}
